import { Box, Chip, Typography } from '@mui/material';
import MicRoundedIcon from '@mui/icons-material/MicRounded';
import { INTER, NAVY, POPPINS, YELLOW } from '../../studentStyles';
import { BLUE_TEXT } from '../../../../mockupPalette';

interface SpeakingHeroProps {
    label: string;
    hanzi?: string;
    // Interface prompts use Inter for reliable pinyin/Latin coverage.
    title?: string;
    // Omitted when the teacher turned pinyin off.
    pinyin?: string;
}

// Every speaking activity shares this banner, including conversations and quizzes.
// It denotes a spoken response, not grading or current playback.
export default function SpeakingHero({ label, hanzi, title, pinyin }: SpeakingHeroProps) {
    return (
        <Box sx={{ p: 3, position: 'relative', overflow: 'hidden', background: `linear-gradient(135deg, ${NAVY} 0%, ${BLUE_TEXT} 100%)` }}>
            <Box sx={{ position: 'absolute', width: 160, height: 160, borderRadius: '50%', backgroundColor: 'rgba(255,255,255,0.08)', right: -40, top: -60 }} />
            <Box sx={{ position: 'absolute', width: 90, height: 90, borderRadius: '50%', backgroundColor: `${YELLOW}38`, left: -25, bottom: -40 }} />
            <Chip
                icon={<MicRoundedIcon />}
                label={label}
                size="small"
                sx={{ position: 'relative', maxWidth: '100%', height: 'auto', minHeight: 24, '& .MuiChip-label': { whiteSpace: 'normal', py: 0.5 }, '& .MuiChip-icon': { color: '#fff' }, fontFamily: INTER, fontWeight: 700, fontSize: 11, letterSpacing: '0.08em', color: '#fff', backgroundColor: 'rgba(255,255,255,0.16)' }}
            />
            <Typography sx={{ position: 'relative', fontFamily: INTER, fontSize: 13, color: '#fff', mt: 1 }}>
                You’ll record your voice.
            </Typography>
            {(title ?? hanzi)?.trim().toLocaleLowerCase() !== label.trim().toLocaleLowerCase() && <Typography sx={{ position: 'relative', fontFamily: title ? INTER : POPPINS, fontWeight: 600, fontSize: 24, color: '#fff', mt: 1.75, lineHeight: 1.3 }}>
                {title ?? hanzi}
            </Typography>}
            {pinyin && (
                <Typography sx={{ position: 'relative', fontFamily: INTER, fontSize: 14, color: '#fff', mt: 0.5 }}>
                    {pinyin}
                </Typography>
            )}
        </Box>
    );
}
